import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Col, Button, Row, Space } from "antd";
import { DatePicker, Input, InputNumber, TimePicker } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/collectTimeSchema";
import { useState } from "react";
import moment from "moment";
import formatTimesByMinutes from "utils/formatter/formatTimesByMinutes";

function formatDate(dateString, pattern = "DD-MM-YYYY") {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format("DD-MM-YYYY");
}


function CollectTimeForm({
  className = "",
  initialValues = {},
  modalType = "view",
  onDraft = () => { },
  onCancel = () => { },
  onSubmit = () => { },
}) {
  const { t } = useTranslation();
  const [startTime, setStartTime] = useState(initialValues?.startTime);
  const [endTime, setEndTime] = useState(initialValues?.endTime);
  const [timeDifference, setTimeDifference] = useState("00:00:00");


  const timeCalc = (start, end) => {
    const startMoment = moment(start, "HH:mm:ss");
    const endMoment = moment(end, "HH:mm:ss");

    let diffInMinutes;

    if (startMoment.isAfter(endMoment)) {
      // Add one day to the end time
      endMoment.add(1, 'days');
      diffInMinutes = endMoment.diff(startMoment, "minutes");
      console.log("after");
    } else {
      diffInMinutes = endMoment.diff(startMoment, "minutes");
      console.log("before");
    }

    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;

    // Format the result as "HH:mm"
    const formattedResult = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    setTimeDifference(formattedResult)

    return formattedResult;
  };

  const handleStartTimeChange = (time) => {
    setStartTime(time);
    if (endTime) {
      timeCalc(time, endTime);
    }
  };

  const handleEndTimeChange = (time) => {
    setEndTime(time);
    if (startTime) {
      timeCalc(startTime, time);
    }
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
        startDate: initialValues?.collectDate ? dayjs(initialValues?.collectDate) : null
      }}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, resetForm = () => { } }) => {
        return (
          <Form className={className}>
            {/* <Divider /> */}
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[0, 12]}>
                <Col span={24}>
                  <DatePicker
                    disabled={modalType == 'view'}
                    name="startDate"
                    label={t('my_request.label.date')}
                    placeholder={t('common.placeholder.ddmmyyyy')}
                    size="large"
                    format={formatDate()}
                    min={dayjs().startOf("year")}
                    max={dayjs().endOf("year")}
                    required
                  />
                </Col>
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <TimePicker
                    disabled={modalType == 'view'}
                    name="startTime"
                    label={t('leave_type.label.start-time')}
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={startTime}
                    onChange={handleStartTimeChange}
                  />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <TimePicker
                    disabled={modalType == 'view'}
                    name="endTime"
                    label={t('leave_type.label.end-time')}
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={endTime}
                    onChange={handleEndTimeChange}
                  />
                </Col>
                <Col span={24}>
                  <Input
                    name="time"
                    label={t('my_request.label.summary')}
                    placeholder={timeDifference}
                    size="large"
                    disabled
                    className="text-right"
                  />
                </Col>
                <Col span={24}>
                  <Input
                    disabled={modalType == 'view'}
                    name="description"
                    label={t('expense.lable.reason')}
                    placeholder={t('expense.lable.pls_fill_reason')}
                    size="large"
                    required
                  />
                </Col>
              </Row>
              <Row justify="end">
                <Space direction="horizontal" size={12}>
                  <Button
                    id="mst__cancelBtn"
                    type="default"
                    onClick={() => {
                      resetForm();
                      onCancel();
                    }}
                    style={{ height: "40px", borderRadius: "8px" }}
                  >
                    {t("common.cancel")}
                  </Button>
                  {modalType == 'view' ? null :
                    <><Button
                      id="mst__cancelBtn"
                      type="default"
                      onClick={() => onDraft(values)}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.draft")}
                    </Button><Button htmlType="submit" type="primary"
                      style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", boxShadow: "none" }}>
                        {t("my_timesheet.label.approve")}
                      </Button></>
                  }
                </Space>
              </Row>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default CollectTimeForm;
